const components = {};

// 读取文件夹下所有index.js文件(包含子目录)
const files = require.context('./', true, /index\.js/);

files.keys().forEach(filePath => {
	if (filePath !== './index.js') {
		// 获取文件名称，作为组件名称
		let fileName = filePath.replace('./', '').replace('\/index.js', '');
		// 读取文件内容
		let fileContent = files(filePath);
		// 若该组件是通过export default导出的，优先使用.default，否则退回到使用模块的根
		components[fileName] = fileContent.default || fileContent;
	}
});

// console.log(components)

export default components